import React from 'react'


import './input.css'
const Configrationinput = () => {

  return (
    <div className='schedule-input'>
        <div className="selectinput1">
            <label htmlFor="text">String</label>
            <input type="text" id='text' />
       </div>
       <div className="selectinput2 in-2">
           <label htmlFor="text">Integer</label>
           <input type="text" id='text' />
       </div>
       <div className="selectinput3 in-2">
           <label htmlFor="text">Decimal</label>
           <input type="text" id='text' />
       </div>
    </div>

  )
}

export default Configrationinput;